import { render, staticRenderFns } from "./CloneModal.vue?vue&type=template&id=407ae242"
import script from "./CloneModal.vue?vue&type=script&lang=ts"
export * from "./CloneModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports